var _g, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconPdfFile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 52,
    viewBox: "0 0 41 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_131_10538)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.5858 2.58579C26.2107 2.21071 25.702 2 25.1716 2H6C4.89543 2 4 2.89543 4 4V44C4 45.1046 4.89543 46 6 46H35C36.1046 46 37 45.1046 37 44L37 13.8284C37 13.298 36.7893 12.7893 36.4142 12.4142L32.7222 8.72222L26.5858 2.58579Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.495 29V27.41H13.095V29H11.495ZM14.3203 30.61V23.83H15.7853L15.7903 24.575C15.867 24.4517 15.9603 24.34 16.0703 24.24C16.1836 24.1367 16.3086 24.0467 16.4453 23.97C16.582 23.8933 16.7303 23.835 16.8903 23.795C17.0503 23.7517 17.2186 23.73 17.3953 23.73C17.7786 23.73 18.1203 23.825 18.4203 24.015C18.7203 24.2017 18.9553 24.4917 19.1253 24.885C19.2986 25.275 19.3853 25.7717 19.3853 26.375C19.3853 27.0017 19.292 27.5167 19.1053 27.92C18.922 28.32 18.6686 28.6167 18.3453 28.81C18.022 29.0033 17.657 29.1 17.2503 29.1C17.0836 29.1 16.927 29.0767 16.7803 29.03C16.6336 28.9867 16.497 28.925 16.3703 28.845C16.247 28.765 16.1353 28.6733 16.0353 28.57C15.9386 28.4633 15.8536 28.3483 15.7803 28.225V30.61H14.3203ZM16.9003 28.03C17.217 28.03 17.482 27.8983 17.6953 27.635C17.912 27.3717 18.0203 26.955 18.0203 26.385C18.0203 25.885 17.917 25.495 17.7103 25.215C17.507 24.9317 17.237 24.79 16.9003 24.79C16.5236 24.79 16.242 24.9433 16.0553 25.25C15.872 25.5533 15.7803 25.9317 15.7803 26.385C15.7803 26.675 15.8203 26.945 15.9003 27.195C15.9836 27.445 16.107 27.6467 16.2703 27.8C16.437 27.9533 16.647 28.03 16.9003 28.03ZM22.2755 29.1C21.5821 29.1 21.0421 28.8617 20.6555 28.385C20.2688 27.905 20.0755 27.2383 20.0755 26.385C20.0755 25.845 20.1538 25.3767 20.3105 24.98C20.4671 24.5833 20.6988 24.2767 21.0055 24.06C21.3121 23.84 21.6871 23.73 22.1305 23.73C22.3171 23.73 22.4905 23.7517 22.6505 23.795C22.8138 23.835 22.9621 23.8917 23.0955 23.965C23.2288 24.0383 23.3455 24.1233 23.4455 24.22C23.5455 24.3167 23.6271 24.42 23.6905 24.53V21.57H25.1555V29H24.0955L23.9305 27.94C23.8838 28.0833 23.8188 28.2233 23.7355 28.36C23.6521 28.4967 23.5455 28.6217 23.4155 28.735C23.2855 28.845 23.1255 28.9333 22.9355 29C22.7488 29.0667 22.5288 29.1 22.2755 29.1ZM22.5955 28.05C22.9621 28.05 23.2355 27.9217 23.4155 27.665C23.5988 27.4083 23.6905 26.975 23.6905 26.365C23.6871 26.0117 23.6455 25.7183 23.5655 25.485C23.4855 25.2517 23.3655 25.0783 23.2055 24.965C23.0488 24.8483 22.8488 24.79 22.6055 24.79C22.2888 24.79 22.0255 24.9117 21.8155 25.155C21.6055 25.395 21.5005 25.7983 21.5005 26.365C21.5005 26.9417 21.5988 27.3667 21.7955 27.64C21.9921 27.9133 22.2588 28.05 22.5955 28.05ZM29.5652 23.83V24.845H28.4752V29H27.0152V24.845H26.0602V23.83H27.0152V23.085C27.0152 22.6683 27.1368 22.345 27.3802 22.115C27.6268 21.885 27.9752 21.77 28.4252 21.77H29.6102L29.6152 22.74H28.9352C28.7485 22.74 28.6202 22.7867 28.5502 22.88C28.4835 22.97 28.4502 23.12 28.4502 23.33V23.83H29.5652Z",
    fill: "#E04F50"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_131_10538",
    x: 0,
    y: 0,
    width: 41,
    height: 52,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_131_10538"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_131_10538",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPdfFile);
export default __webpack_public_path__ + "static/media/icon_pdf_file.eed43d62b8e0dbb39caaa47a6919b24a.svg";
export { ForwardRef as ReactComponent };